import React from "react";
import { createBrowserRouter } from "react-router-dom";
import ErrorPage from "../Pages/Shared/ErrorPage";
import Login from "../Pages/Login/Login";
import Signup from "../Pages/Login/Signup";
import Main from "../Layout/Main";
import ComingSoon from "../Pages/Shared/ComingSoon";
import Details from "../Pages/Details";
import SearchResult from "../Pages/SearchResult";
import PrivateRoute from "./PrivateRoute";
import DashboardLayout from "../Layout/DashboardLayout";

import Welcome from "../Pages/Dashboard/Welcome";

import AdminRoute from "./AdminRoute";

import HomeAll from "../Pages/HomeAll";
import ProductDetails from "../Pages/ProductDetails";
import ProductsList from "../Pages/ProductsList";
import AdminDashboard from "../Components/Dashboard/AdminAllPage/AdminDashboard/AdminDashboard";
import MyProducts from "../Components/Dashboard/AdminAllPage/MyProducts/MyProducts";
import AddProducts from "../Components/Dashboard/AdminAllPage/AddProducts/AddProducts";
import Orders from "../Components/Dashboard/AdminAllPage/Orders/Orders";
import AllUsersAdmin from "../Components/Dashboard/AdminAllPage/AllUsersAdmin/AllUsersAdmin";
import MiraiConsultation from "../Pages/Login/MiraiAllPage/MiraiConsultation";
import AddServiceMirai from "../Components/Dashboard/AdminMirai/AddServiceMirai";
import MiraiService from "../Pages/Login/MiraiAllPage/MiraiService";
import MiraiAboutUs from "../Pages/Login/MiraiAllPage/MiraiAboutUs";
import AllService from "../Components/Dashboard/AdminMirai/AllService";
import QuotationRequest from "../Components/Dashboard/AdminMirai/QuotationRequest";
import ConsultationRequest from "../Components/Dashboard/AdminMirai/ConsultationRequest";
import AddNews from "../Components/Dashboard/AdminMirai/AddNews";
import AllNews from "../Components/Dashboard/AdminMirai/AllNews";
import MiraiNewsAllPage from "../Pages/Login/MiraiAllPage/MiraiNewsAllPage";
import MiraiNewsDetails from "../Pages/Login/MiraiAllPage/MiraiNewsDetails";
import AddGellary from "../Components/Dashboard/AdminMirai/AddGallary";
import GallaryData from "../Components/Dashboard/AdminMirai/GallaryData";
import MiraiGallery from "../Pages/Login/MiraiAllPage/MiraiGallery";
import MiraiGalleryDetails from "../Pages/Login/MiraiAllPage/MiraiGalleryDetails";
import MiraiCareer from "../Pages/Login/MiraiAllPage/MiraiCareer";
import AddJobs from "../Components/Dashboard/AdminMirai/AddJobs";
import MiraiCareerDetails from "../Pages/Login/MiraiAllPage/MiraiCareerDetails";
import AllJobs from "../Components/Dashboard/AdminMirai/AllJobs";
import AdminJobDetails from "../Components/Dashboard/AdminMirai/AdminJobDetails.js";
import BangladeshSubsidiary from "../Pages/Login/MiraiAllPage/MiraiAboutUsAll/BangladeshSubsidiary.js";
import CorporatePhilosophy from "../Pages/Login/MiraiAllPage/MiraiAboutUsAll/CorporatePhilosophy.js";
import GroupCompany from "../Pages/Login/MiraiAllPage/MiraiAboutUsAll/GroupCompany.js";
import Team from "../Pages/Login/MiraiAllPage/MiraiAboutUsAll/Team.js";
import MiraiCategoryCareer from "../Pages/Login/MiraiAllPage/MiraiCareer/MiraiCategoryCareer.js";
import AddTeam from "../Components/Dashboard/AdminMirai/AddTeam.js";
import AllTeam from "../Components/Dashboard/AdminMirai/AllTeam.js";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Main />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <HomeAll></HomeAll>,
      },
      {
        path: "/login",
        element: <Login />,
      },
      {
        path: "/signup",
        element: <Signup />,
      },

      {
        path: "/coming-soon",
        element: <ComingSoon />,
      },
      {
        path: "/consultation",
        element: <MiraiConsultation />,
      },

      {
        path: "/service/:id",
        element: <MiraiService />,
        loader: ({ params }) =>
          fetch(`https://mirai-server.vercel.app/service-data/${params.id}`),
      },
      {
        path: "/about-us",
        element: <MiraiAboutUs />,
      },
      {
        path: "/bangladesh-subsidiary",
        element: <BangladeshSubsidiary></BangladeshSubsidiary>,
      },
      {
        path: "/corporate-philosophy",
        element: <CorporatePhilosophy></CorporatePhilosophy>,
      },
      {
        path: "/group-company",
        element: <GroupCompany></GroupCompany>,
      },
      {
        path: "/team",
        element: <Team></Team>,
      },
      {
        path: "/career",
        element: <MiraiCareer />,
      },
      {
        path: "/career-category/:category",
        element: <MiraiCategoryCareer />,
        loader: ({ params }) => ({ category: params.category }),
      },
      

      {
        path: "/career-details/:id",
        element: <MiraiCareerDetails />,
        loader: ({ params }) =>
          fetch(`https://mirai-server.vercel.app/api/jobs/${params.id}`),
      },
      {
        path: "/news",
        element: <MiraiNewsAllPage />,
      },
      {
        path: "/news-details/:id",
        element: <MiraiNewsDetails />,
        loader: ({ params }) =>
          fetch(`https://mirai-server.vercel.app/news-home-data/${params.id}`),
      },
      {
        path: "/gallery",
        element: <MiraiGallery />,
      },
      {
        path: "/gallery-details/:id",
        element: <MiraiGalleryDetails />,
        loader: ({ params }) =>
          fetch(`https://mirai-server.vercel.app/gallery-home-data/${params.id}`),
      },
      {
        path: "/search-result",
        element: <SearchResult />,
      },
      {
        path: "/products",
        element: <ProductsList />,
        loader: ({ request }) => {
          const url = new URL(request.url);
          const page = url.searchParams.get("page") || 1; // Get page from URL query params
          return fetch(`https://mirai-server.vercel.app/products?page=${page}&limit=5`);
        },
      },

      {
        path: "/product-details/:id", // Product details page route
        element: <ProductDetails />,
        loader: ({ params }) =>
          fetch(`https://mirai-server.vercel.app/products/${params.id}`), // Fetch product details using ID
      },
    ],
  },
  {
    path: "/dashboard",
    errorElement: <ErrorPage />,
    element: (
      <PrivateRoute>
        <DashboardLayout />
      </PrivateRoute>
    ),
    children: [
      {
        path: "",
        element: (
          <PrivateRoute>
            <Welcome />
          </PrivateRoute>
        ),
      },
      {
        path: "admin-dashboard",
        element: (
          <AdminRoute>
            <AdminDashboard />
          </AdminRoute>
        ),
      },
      {
        path: "add-service",
        element: (
          <AdminRoute>
            <AddServiceMirai />
          </AdminRoute>
        ),
      },
      {
        path: "all-service",
        element: (
          <AdminRoute>
            <AllService />
          </AdminRoute>
        ),
      },
      {
        path: "quotation-req",
        element: (
          <AdminRoute>
            <QuotationRequest />
          </AdminRoute>
        ),
      },
      {
        path: "consultation-req",
        element: (
          <AdminRoute>
            <ConsultationRequest />
          </AdminRoute>
        ),
      },
      {
        path: "add-news",
        element: (
          <AdminRoute>
            <AddNews />
          </AdminRoute>
        ),
      },
      {
        path: "all-news",
        element: (
          <AdminRoute>
            <AllNews />
          </AdminRoute>
        ),
      },
      {
        path: "add-gallery",
        element: (
          <AdminRoute>
            <AddGellary />
          </AdminRoute>
        ),
      },
      {
        path: "all-gallery",
        element: (
          <AdminRoute>
            <GallaryData />
          </AdminRoute>
        ),
      },
      {
        path: "add-jobs",
        element: (
          <AdminRoute>
            <AddJobs />
          </AdminRoute>
        ),
      },
      {
        path: "all-jobs",
        element: (
          <AdminRoute>
            <AllJobs />
          </AdminRoute>
        ),
      },

      {
        path: "orders",
        element: (
          <AdminRoute>
            <Orders />
          </AdminRoute>
        ),
      },
      {
        path: "all-users",
        element: (
          <AdminRoute>
            <AllUsersAdmin />
          </AdminRoute>
        ),
      },
      {
        path: "job-details/:id",
        element: (
          <AdminRoute>
            <AdminJobDetails />
          </AdminRoute>
        ),
        loader: ({ params }) =>
          fetch(`https://mirai-server.vercel.app/api/jobs/${params.id}`),
      },
      {
        path: "add-team",
        element: (
          <AdminRoute>
            <AddTeam />
          </AdminRoute>
        ),
      },
      {
        path: "all-team",
        element: (
          <AdminRoute>
            <AllTeam />
          </AdminRoute>
        ),
      },
      // E-END
    ],
  },
]);

export default router;
